

import React, { useEffect, useState } from "react";
import styles from "./Searchpg.module.css";
import SearchIcon from "@mui/icons-material/Search";
import { SearchData } from "./SearchData";
import SearchCard from "./SearchCard";
import { useParams } from "react-router-dom";

const Searchpg = () => {
  
  const {query}= useParams();
  const userInput = query.substring(2).split("+")
  const currquery = query.substring(2).toLowerCase().split("+")  
  // const matchingCard = SearchData.find(
  //   // (item) => item.name.toLowerCase().includes(query.substring(2).toLowerCase())
  // );
  const matchingCard = SearchData.find((data)=>(
    currquery.every((term)=> data.name.toLowerCase().includes(term))
  ))

  // const remainingCards = SearchData.filter(
  //   (item) => !item.name.toLowerCase().includes(query.substring(2).toLowerCase())
  // );

  
  if(!matchingCard) {
     return (
     <>
     <div className={styles.hero}>
        <div className="hero_img values_mobile_img">
          <img src="/assets/search.jpg" alt="" />
        </div>
        
      </div>
      <div className={styles.container} >
      <div className={styles.heading}>
        <h1>Search Results for: {currquery}</h1>
        <p style={{color:"#2D3985"}}>It seems we cannot find what you're looking for.</p>
       </div>
         
      </div>
     
     </>  
   
   )
 }

 
  return (
    <div>
      <div className={styles.hero}>
        <div className="hero_img Search_mobile_img">
          <img src="/assets/search.jpg" alt="" />
        </div>
       
      </div>

      <div className={styles.container}>
        <div className={styles.heading}>
          <h1>Search Results for: {userInput}</h1>
        </div>
          <div className={styles.searchCardContainer} >
         
            
            {matchingCard && (
          <SearchCard
            key={matchingCard.id}
            title={matchingCard.title}
            desc={matchingCard.desc}
            url={matchingCard.url}
          />
        )}

        {/* {remainingCards.map((item) => (
          <SearchCard key={item.id} title={item.name} desc={item.desc} url={item.url} />
        ))} */}
          </div>
         
        </div>
      </div>
  );
};

export default Searchpg;
